export const statusChoices = [
  { id: "PENDING", name: "Pendiente" },
  { id: "REVIEW", name: "Revisión" },
  { id: "APPROVED", name: "Aprobado" },
  { id: "REJECTED", name: "Rechazado" },
];
